import { Box, Typography, keyframes } from "@mui/material";
import React from "react";

interface LoadingStatusProps {
  isLoading: boolean;
  isWorking: boolean;
}

// Create keyframe animation for the ellipsis
const ellipsisAnimation = keyframes`
  0% { opacity: 0; }
  50% { opacity: 1; }
  100% { opacity: 0; }
`;

export const LoadingStatus: React.FC<LoadingStatusProps> = ({
  isLoading,
  isWorking,
}) => {
  const text = "Thinking";
  if (isWorking || !isLoading) return null;

  return (
    <Box
      data-testid="chat-loading-status"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "left",
        // px: 2,
        my: 2,
      }}
    >
      <Typography
        color="textDisabled"
        sx={{
          // color: "text.primary",
          display: "inline-flex",
          alignItems: "left",
          // fontStyle: "italic",
          fontFamily: "Roboto, Arial, sans-serif",
          // fontWeight: "500",
          fontSize: "0.875rem",
          "& .dot": {
            display: "inline-block",
            animation: `${ellipsisAnimation} 2.5s infinite`,
            "&:nth-of-type(2)": {
              animationDelay: "0.2s",
            },
            "&:nth-of-type(3)": {
              animationDelay: "0.4s",
            },
          },
        }}
      >
        {text}
        <span className="dot">. </span>
        <span className="dot">. </span>
        <span className="dot">. </span>
      </Typography>
    </Box>
  );
};
